// The gate queue page is the single view for a session — Acknowledge/Initiate,
// pause/cancel and time management all live there. Each role reaches it through
// its own route (layout differs); ?session= pins the exact session, since a gate
// can have several sessions queued across the day.
export function queuePathFor(role, gateId, sessionId) {
  const base = role === 'gate_operator'
    ? `/operator/queue/${gateId}`
    : role === 'admin'
      ? `/admin/gates/${gateId}/queue`
      : `/supervisor/queue/${gateId}`;
  return sessionId ? `${base}?session=${sessionId}` : base;
}
